var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7823_3491)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7823_3491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 28V27H26V28C26 29.1 25.1 30 24 30H4C2.9 30 2 29.1 2 28V4C2 2.9 2.9 2 4 2H16V11C16 11.6 16.4 12 17 12H26V14H28V11L27.3 10.3L17.7 0.7L17 0H4C1.8 0 0 1.8 0 4V28C0 30.2 1.8 32 4 32H24C26.2 32 28 30.2 28 28ZM18 3.8L24.2 10H18V3.8Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 20.9998V24.3998H16.7V17.2998H14.6L12.8 22.7998L11.1 17.2998H9V24.3998H10.4V20.9998C10.4 20.5998 10.4 19.8998 10.3 18.6998L12 24.2998H13.4L15.2 18.6998C15.2 19.5998 15.1 20.1998 15.1 20.3998C15.3 20.5998 15.3 20.7998 15.3 20.9998Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 17.2002H18.3V24.3002H19.8V17.2002Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 23.2C23 23.2 22.7 23.2 22.4 23.1C22.1 23 21.7 22.9 21.2 22.6V24C21.8 24.3 22.5 24.4 23.2 24.4C24 24.4 24.7 24.2 25.1 23.8C25.6 23.4 25.8 22.9 25.8 22.3C25.8 21.8 25.7 21.4 25.4 21.1C25.2 20.8 24.7 20.5 24 20.1C23.5 19.9 23.2 19.7 23 19.6C22.9 19.5 22.8 19.4 22.7 19.3C22.6 19.2 22.6 19.1 22.6 19C22.6 18.8 22.7 18.6 22.8 18.5C23 18.4 23.2 18.3 23.5 18.3C23.7 18.3 24 18.3 24.2 18.4C24.4 18.5 24.8 18.6 25.1 18.7L25.6 17.5C25.2 17.3 24.9 17.2 24.5 17.1C24.2 17 23.8 17 23.4 17C22.6 17 22.1 17.2 21.6 17.5C21.2 17.9 21 18.4 21 19C21 19.3 21.1 19.6 21.2 19.9C21.3 20.2 21.5 20.4 21.7 20.6C21.9 20.8 22.2 21 22.7 21.2C23.2 21.4 23.5 21.6 23.6 21.7C23.8 21.8 23.9 21.9 23.9 22C24 22.1 24 22.2 24 22.4C24 22.7 23.9 22.8 23.7 23C23.9 23.1 23.6 23.2 23.3 23.2Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 17.5C27.6 17.8 27.2 18.2 26.9 18.8C26.6 19.4 26.5 20 26.5 20.8C26.5 22 26.8 22.9 27.3 23.5C27.8 24.1 28.6 24.4 29.7 24.4C30.4 24.4 31.1 24.3 31.7 24V22.7C31 23 30.4 23.1 29.9 23.1C28.7 23.1 28.1 22.3 28.1 20.7C28.1 19.9 28.3 19.3 28.6 18.9C28.9 18.5 29.4 18.3 29.9 18.3C30.2 18.3 30.4 18.3 30.7 18.4C31 18.5 31.2 18.6 31.5 18.7L32 17.5C31.3 17.2 30.6 17 29.9 17C29.2 17.1 28.6 17.2 28.1 17.5Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7823_3491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7823_3491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscDocs);
export default __webpack_public_path__ + "static/media/misc_docs.0ff1a228b162090fcd97ede96a362d2f.svg";
export { ForwardRef as ReactComponent };